<template>
  <comparison-graph :date-range="dateRange" :biz="biz" :top-performer="topPerformer" api-endpoint="nps-breakdown">
    <div class="is-flex">
      <table class="table is-fullwidth summary-table">
        <thead>
        <tr>
          <td class="pad-top-35">Business</td>
          <td class="pad-top-35 w70">NPS score</td>
          <td class="pad-top-35">Responses</td>
          <td>
            <p class="nps-image detractors">Detractors (0-6)</p>
          </td>
          <td>
            <p class="nps-image passives">Passives (7-8)</p>
          </td>
          <td>
            <p class="nps-image promoters">Promotors (9-10)</p>
          </td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="record in breakdownData">
          <td>{{ record.name }}</td>
          <td>{{ Math.floor(record.nps_total) }}</td>
          <td>{{ record.nps_detail.totalRespondents }}</td>
          <td>
            <div class="is-flex">
              <progress class="progress custom-progress is-one margin-right-5 margin-top-3"
                        :value="calcProgressPercent(record.nps_detail.detractors, record.nps_detail.totalRespondents)"
                        max="100"/>
              {{record.nps_detail.detractors}}
            </div>
          </td>
          <td>
            <div class="is-flex">
              <progress class="progress custom-progress is-three margin-right-5 margin-top-3"
                        :value="calcProgressPercent(record.nps_detail.passives, record.nps_detail.totalRespondents)"
                        max="100"/>
              {{record.nps_detail.passives}}
            </div>
          </td>
          <td>
            <div class="is-flex">
              <progress class="progress custom-progress is-five margin-right-5 margin-top-3"
                        :value="calcProgressPercent(record.nps_detail.promoters, record.nps_detail.totalRespondents)"
                        max="100"/>
              {{record.nps_detail.promoters}}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="score-explain-box">
        <div class="has-text-weight-bold">NPS scores explained</div>
        <div class="is-flex margin-top-20">
          <div class="score-explain-box__score">Less than 0</div>
          <div>This isn’t great</div>
        </div>
        <div class="is-flex margin-top-20">
          <div class="score-explain-box__score">Between 1 and 49</div>
          <div>This is good, you’re out of the negatives!</div>
        </div>
        <div class="is-flex margin-top-20">
          <div class="score-explain-box__score">Between 50 and 69</div>
          <div>This is excellent!</div>
        </div>
        <div class="is-flex margin-top-20">
          <div class="score-explain-box__score">70 and over</div>
          <div>World class</div>
        </div>
      </div>
    </div>
  </comparison-graph>
</template>

<script>
  import ComparisonGraph from './ComparisonGraph'
  import {misc} from '@/mixins'

  export default {
    name: 'NPSCompare',
    components: {ComparisonGraph},
    mixins: [misc],
    props: {
      dateRange: {
        type: Object,
        required: true
      },
      biz: {
        type: Array,
        required: true
      },
      summary: {
        type: Array,
        required: true
      }
    },
    computed: {
      breakdownData () {
        const data = []
        if (this.biz.length && this.summary.length) {
          this.biz.forEach(b => {
            const summary = this.summary.find(summaryBiz => summaryBiz.business_id === b.id)
            if (summary) {
              data.push(summary)
            }
          })
        }
        return data
      },
      topPerformer () {
        const data = {name: '', score: ''}

        if (this.breakdownData.length) {
          const max = this.breakdownData.reduce((prev, current) => {
            return (!current.nps_detail.totalRespondents || prev.nps_total > current.nps_total) ? prev : current
          })
          data.name = max.name
          data.score = Math.floor(max.nps_total)
        }

        return data
      }
    }
  }
</script>

<style scoped>
  .summary-table {
    background-color: #fafafa;
    margin-top: 30px;
    margin-bottom: 0;
  }

  .summary-table.table tbody tr {
    background-color: #fafafa !important;
  }

  .summary-table tbody td {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
  }

  .pad-top-35 {
    padding-top: 35px !important;
  }

  .progress {
    width: 100px;
  }

  .nps-image {
    background-size: 23px 23px;
    padding-top: 25px;
  }

  .detractors {
    width: 80px;
  }

  .passives {
    width: 70px;
  }

  .promoters {
    width: 90px;
  }

  .w70 {
    width: 70px
  }

  .score-explain-box {
    margin-left: 30px;
    width: 270px;
    border: solid 1px rgba(88, 89, 91, 0.32);
    margin-top: 55px;
    padding: 15px;
    color: #58595b;
    font-size: 11px;
    margin-bottom: 10px;
    height: 229px
  }

  .score-explain-box__score {
    width: 70px;
    min-width: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/analytics/competitors/NPSCompare.vue